import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.js";
Vue.use(VueI18n);
const langkey = 'en';
Vue.locale = () => {};

const i18n = new VueI18n({
  locale: langkey,
  fallbackLocale: "en",
  messages: {
    en,
  }
});

export default i18n;
